<!--通用弹窗-->
<template>
    <div class="mask">
        <div class="tip-content item-center" :class="currentChannel.channel">
            <div v-if="isShowHeader" class="title display-y-center display-s-b">
                {{ title }}
            </div>
            <div class="content">
                <slot></slot>
            </div>
            <img v-if="isShowClose" class="btn-close" src="@/assets/images/common/btn_close.png" @click="emits('onClose')" />
        </div>
    </div>
</template>

<script lang="ts" setup>
import { currentChannel } from '@/config/config';


defineProps({
    title: {
        type: String,
        default: "",
    },
    isShowClose: {
        type: Boolean,
        default: true
    },
    isShowHeader: {
        type: Boolean,
        default: true,
    }
});

const emits = defineEmits(["onClose"]);
</script>

<style lang="less" scoped>
.tip-content {
    position: absolute;
    width: calc(100% - 20rem);
    height: auto;
    background-color: #162A3B;
    border-radius: 5rem;
    box-sizing: border-box;
    .title {
        width: 100%;
        height: 50rem;
        font-size: 20rem;
        font-weight: bold;
        color: #FFF;
        background-color: #0F1D29;
        padding: 0 10rem;
        box-sizing: border-box;
        position: relative;
        >img {
            width: 70rem;
            position: absolute;
            right: 0;
            top: -20rem;
        }
    }
    .content {
        position: relative;
        width: 100%;
        color: rgba(255, 255, 255, .5);
    }
    &.EG {
        .title {
            >img {
                right: auto;
                left: 0;
            }
        }
    }
}
.btn-close {
    width: 30rem;
    height: 30rem;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: -50rem;
}
</style>